interface EmailLinkSearch {
  source?: string;
  cta?: string;
}

export const validateEmailLinkSearch = (
  search: Record<string, unknown>,
): EmailLinkSearch => ({
  source: typeof search.source === "string" ? search.source : undefined,
  cta: typeof search.cta === "string" ? search.cta : undefined,
});
